import React from "react";
import { Container, wrap, Store } from "AppReact";
import { SolidButton } from "molecules";
import { WebCam } from "./atoms";
import { ButtonWrapper, WebCamWrapper } from "./wrappers";

const WrappedButton = wrap(SolidButton, ButtonWrapper);
const screenshotRef = React.createRef();

const ModalBody = Container({
  name: "ModalBody",
  props: {
    property: Store,
    uploadedDoc: Store,
    photoIDs: Store,
    toggleWebCam: Store,
    optionalDocs: Store,
    screenshotRef,
    webCamLoading: true,
  },
  elements: [

    {
      wrapper: WebCamWrapper,
      name: "WebCamWrapper",
      elements: [
        {
          component: WebCam,
          name: "WebCam",
          displayValue: ({ screenshotRef }) => {
            const _onChange = ({ handle }, o) => handle(o);
            return {
              audio: false,
              width: 400,
              height: 300,
              ref: screenshotRef,
              screenshotFormat: "image/jpeg",
              _onChange,
              onChangeField: "onElementClick",
            };
          },
        },
      ],
    },
    {
      component: WrappedButton,
      name: "screenshotButton",
      bindings: ({
        optionalDocs,
        screenshotRef,
        uploadedDoc,
        photoIDs,
        toggleWebCam,
        webCamLoading,
      }) => {
        return {
          optionalDocs,
          toggleWebCam,
          uploadedDoc,
          photoIDs,
          screenshotRef,
          title: webCamLoading ?  "Web cam connecting...":"Save screenshot",
          big: true,
          disabled: webCamLoading,
        };
      },
    },
  ],
});

export default ModalBody;
